module.exports = __webpack_public_path__ + "602357723fce5c16667bf7b19c11b751.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-bolditalic/opensans-bolditalic.woff
// module id = ./src/styles/fonts/opensans-bolditalic/opensans-bolditalic.woff
// module chunks = index